module.exports = __webpack_public_path__ + "img/td-icon3.4173cf81.png";